import { ChangeDetectorRef, Component, computed, inject, signal } from '@angular/core';
import { DataService } from '../../services/data';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { AppUrl } from '../../appUrl';
import { catchError, finalize, of, switchMap } from 'rxjs';
import { toObservable, toSignal } from '@angular/core/rxjs-interop';
import { StorageService } from '../../services/storage-service';
import { environment } from '../../../environments/environment';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '../../shareds/translate/translate.module';
import { LanguageSwitcher } from '../../shareds/translate/language-switcher';
import { ThemeService } from '../../services/theme.service';

@Component({
  selector: 'app-list-location',
  imports: [CommonModule, TranslateModule, LanguageSwitcher],
  templateUrl: './list-location.html',
  styleUrl: './list-location.scss',
})
export class ListLocation {
  protected theme = inject(ThemeService);
  constructor(private data: DataService,
    private http: HttpClient,
    private router: Router,
    private ac: ActivatedRoute,
    private st: StorageService,
    private cdr: ChangeDetectorRef
  ) {

  }
  imgURL = environment.imgURL;
  dateRange: Date[] = [];
  ngOnInit(): void {
    this.dateRange = [
      new Date(),
      new Date(new Date().setDate(new Date().getDate() + 7))
    ];
  }
  searchQuery = signal('');
  loadingBranch = signal(false);

  private reload = signal(0);                 // ✅ เป็น signal
  private reload$ = toObservable(this.reload); // ✅ แปลงเป็น Observable

  branchRes = toSignal(
    this.reload$.pipe(
      switchMap(() => {
        this.loadingBranch.set(true);
        return this.http.get<any>(`/api/Public/ReserveHotel/Branch`).pipe(
          finalize(() => this.loadingBranch.set(false)),
          catchError(() => of({ data: [] }))  // ✅ ต้องคืน “object” ไม่ใช่ array
        );
      })
    ),
    { initialValue: { data: [] } as any }
  );

  branchItems = computed(() => this.branchRes()?.data ?? []);

  filteredItems = computed(() => {
    const q = this.searchQuery().trim().toLowerCase();
    if (!q) return this.branchItems();
    return this.branchItems().filter((item: any) =>
      (item.name ?? '').toLowerCase().includes(q) ||
      (item.address ?? '').toLowerCase().includes(q)
    );
  });

  selectBranch(item: any) {
    this.router.navigate(['/', AppUrl.list_room, this.ac.snapshot.params['app-id'], item.id]);
  }

  toBack() {
    this.router.navigate(['/', AppUrl.list_room, this.ac.snapshot.params['app-id'], this.ac.snapshot.params['branch-id']])
  }
}
